<template>
  <div>
    <neo-print-wrapper title="Fee Receipt" :schoolData="schoolData">
      <div
        class="mb-3"
        v-for="(payment, index) in studentFeeData.student_fees_payment"
        :key="payment.id"
      >
        <div class="row mb-2">
          <div class="col-12">
            <h4>{{ student.first_name }} {{ student.last_name }}</h4>
            <p class="mb-2">
              Student code:
              <span class="font-weight-bold">{{ student.student_code }}</span> |
              Class:
              <span class="font-weight-bold">{{ student.class_name }}</span> |
              Section:
              <span class="font-weight-bold">{{ student.section_name }}</span> |
              Roll No:
              <span class="font-weight-bold">{{ student.roll_no }}</span>
            </p>
          </div>
        </div>
        <!-- Fee details -->
        <div class="row mb-2">
          <div class="col-md-6">
            Ref. No.:
            <span class="font-weight-bold">{{
              payment.student_fee_payment.reference_number
            }}</span>
          </div>
          <div class="col-md-6 text-md-right">
            Paid on:
            <span class="font-weight-bold">{{
              moment(payment.student_fee_payment.payment_date).format("LL")
            }}</span>
          </div>
        </div>
        <div>
          <vue-custom-scrollbar class="scroll-area">
            <table class="table table-sm table-bordered">
              <tbody>
                <tr>
                  <td colspan="2">
                    <table class="table table-lg table-borderless">
                      <thead>
                        <tr>
                          <th>Fee</th>
                          <th>Amount</th>
                          <th>Fine</th>
                          <th>Dis.</th>
                          <th>Dis. %</th>
                          <th>Due</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="paidFee in payment.student_fee_payment
                            .student_fees_payment"
                          :key="paidFee.id"
                        >
                          <th>
                            {{
                              paidFee.student_fee.fee_setting.class_fee ? paidFee.student_fee.fee_setting.class_fee.fee.name : paidFee.student_fee.fee_setting.fee.name
                            }}
                            ({{
                              getFeeType(
                                paidFee.student_fee.fee_setting.class_fee ? paidFee.student_fee.fee_setting.class_fee.fee.type : paidFee.student_fee.fee_setting.fee.type
                              )
                            }})
                          </th>
                          <td>₹ {{ paidFee.student_fee.amount }}</td>
                          <td>₹ {{ paidFee.student_fee.fine }}</td>
                          <td>₹ {{ paidFee.student_fee.discount_amount || 0}}</td>
                          <td>
                            {{
                              paidFee.student_fee.discount_percentage ||
                              0
                            }}
                            %
                          </td>
                          <td>
                            ₹ {{ paidFee.student_fee.due_amount }}
                          </td>
                          <td>
                            <!-- ₹ {{ payment.student_fee_payment.fee_payable || 0 }} -->
                            ₹ {{ paidFee.student_fee.fee_total }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <th>Addl. Fine</th>
                  <!-- <td class="text-right px-4">
                    ₹ {{ getFineAmount(payment) }}
                  </td>-->
                  <td class="text-right px-4">
                    ₹ {{ payment.student_fee_payment.fine || 0 }}
                  </td>
                </tr>
                <tr>
                  <th>Addl. Discount</th>
                  <!-- <td class="text-right px-4">
                    ₹ {{ getDiscountAmount(payment) }}
                  </td>-->
                  <td class="text-right px-4">
                    ₹ {{ payment.student_fee_payment.discount_amount || 0 }}
                  </td>
                </tr>
                <tr>
                  <th>Addl. Discount %</th>
                  <td class="text-right px-4">
                    {{ payment.student_fee_payment.discount_percentage || 0 }} %
                  </td>
                </tr>
                <tr>
                  <th>Total Due</th>
                  <td class="text-right px-4">
                    ₹ {{ payment.student_fee_payment.due_amount || 0 }}
                  </td>
                </tr>
                <tr class="bg-light">
                  <th>Fee Payable</th>
                  <td class="font-weight-bold text-right px-4">
                    ₹ {{ payment.student_fee_payment.fee_payable }}
                  </td>
                </tr>
              </tbody>
            </table>
          </vue-custom-scrollbar>
        </div>
        <div class="row">
          <div class="col-md-6">
            Paid Amount:
            <span class="font-weight-bold"
              >₹ {{ payment.student_fee_payment.paid_amount }}</span
            >
          </div>
          <div class="col-md-6">
            Remaining Payable:
            <span class="font-weight-bold"
              >₹ {{ payment.student_fee_payment.due_payable || 0 }}</span
            >
          </div>
          <div class="col-md-6">
            Paid by:
            <span class="font-weight-bold">{{
              payment.student_fee_payment.paid_by
            }}</span>
          </div>
          <div class="col-md-6">
            Payment Mode:
            <span class="font-weight-bold">{{
              getPaymentMode(payment.student_fee_payment.payment_type)
            }}</span>
          </div>
          <div class="col-md-6">
            Remark:
            <span class="font-weight-bold">{{
              payment.student_fee_payment.remark
            }}</span>
          </div>
        </div>

        <hr v-if="index < studentFeeData.student_fees_payment.length - 1" />
      </div>
    </neo-print-wrapper>
  </div>
</template>

<script>
import moment from 'moment'
import { find } from 'lodash'
import vueCustomScrollbar from 'vue-custom-scrollbar'

import NeoPrintWrapper from '@/components/layout/Print/Default'

import { paymentTypes, feeTypes } from '@/services/globaldata'
export default {
  props: ['studentFeeData', 'student', 'schoolData'],
  components: {
    vueCustomScrollbar,
    NeoPrintWrapper,
  },
  data: function () {
    return {
      paymentTypes,
      feeTypes,
      studentFeesData: null,
      feesToPay: [],
    }
  },
  watch: {
    feesToPay: function (val) {
      let total = 0
      val.forEach((element) => {
        total = total + element.due_amount
      })
      this.feeTotal = total
    },
  },
  methods: {
    moment,
    find,
    getPaymentMode(type) {
      return find(this.paymentTypes, { value: type }).name
    },
    getFeeType(type) {
      return find(this.feeTypes, { value: type }).name
    },
    getDiscountAmount(payment) {
      let discountTotal = payment.student_fee_payment.discount_amount
      payment.student_fee_payment.student_fees_payment.forEach((element) => {
        const feeDiscount = element.student_fee.discount_amount
        discountTotal = discountTotal + feeDiscount
      })
      return discountTotal
    },
    getFineAmount(payment) {
      let fineTotal = payment.student_fee_payment.fine
      payment.student_fee_payment.student_fees_payment.forEach((element) => {
        const feeDiscount = element.student_fee.fine
        fineTotal = fineTotal + feeDiscount
      })
      return fineTotal
    },
  },
}
</script>
